module.exports = __webpack_public_path__ + "static/media/img-location-taipei-en.babd73c9.svg";